import { RatingResponse } from '../../../models/review-insights-models/rating-response';
import { ReviewNumbersResponse } from '../../../models/review-insights-models/review-numbers-response';
import { LocationComparisonOverviewResponseEntry } from '../../../models/review-insights-models/location-comparison-overview-response-entry';
import { LocationComparisonResponseEntry } from '../../../models/review-insights-models/location-comparison-response-entry';
import { RespondedCommentedResponse } from '../../../models/review-insights-models/responded-commented-response';
import { ResponseTimesResponse } from '../../../models/review-insights-models/response-times-response';
import { ChartDatapointSeries } from '../../../models/review-insights-models/chart-datapoint-series';
import { ChartDatapoint } from '../../../models/review-insights-models/chart-datapoint';
import { MapLocationInterface } from '../../../models/review-insights-models/map-location';
import { ReviewInsightsFilterInterface, TimeRangeBucketFormat } from '../../../models/review-insights-models/review-insights-filter';
import { LocationComparisonTableSettings, SortFields } from '../../../models/review-insights-models/location-comparison-filter';
import { SortingEnum } from '../../locations-skeleton/enums/sorting-enum';
import { Dictionary } from '@ngrx/entity';

export interface ReviewInsightsFeatureState {
  rating: RatingResponse,
  reviewNumbers: ReviewNumbersResponse,
  topLocations: LocationComparisonOverviewResponseEntry[],
  locationComparisonList: LocationComparisonResponseEntry[],
  locationComparisonCount: number,
  respondedCommented: RespondedCommentedResponse,
  responseTimes: ResponseTimesResponse,
  responseTimesOverview: number,
  postTimes: ChartDatapointSeries[],
  postsPerWeekday: ChartDatapoint[],
  mapLocations: MapLocationInterface[],
  filters: ReviewInsightsFilterInterface,
  filtersForSuccessfulInsightsCalls: Dictionary<object>
  locationComparisonTableSettings: LocationComparisonTableSettings,
}

export const InitialState: ReviewInsightsFeatureState = {
  rating: null,
  reviewNumbers: null,
  topLocations: null,
  locationComparisonList: null,
  locationComparisonCount: null,
  respondedCommented: null,
  responseTimes: null,
  responseTimesOverview: null,
  postTimes: null,
  postsPerWeekday: null,
  mapLocations: null,
  filters: {
    storeCode: null,
    businessName: null,
    city: null,
    countryCodes: null,
    fromDate: null,
    toDate: null,
    days: null,
    bucketFormat: TimeRangeBucketFormat.MONTH,
  },
  locationComparisonTableSettings: {
    pageSize: 10,
    pageIndex: 0,
    sortField: SortFields.GX_SCORE,
    sortDirection: SortingEnum.DESCENDING,
  },
  filtersForSuccessfulInsightsCalls: {},
};
